import React from 'react';
import { Box, Typography } from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { colors } from '../constants';

export default function EmptyState({ icon, title = 'Nothing here yet', message }) {
  return (
    <Box
      sx={{
        py: 8,
        px: 2,
        textAlign: 'center',
        color: colors.gray500,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box sx={{ fontSize: 48, color: colors.gray400, display: 'flex' }}>
        {icon || <Inventory2OutlinedIcon fontSize="inherit" />}
      </Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: colors.gray600 }}>
        {title}
      </Typography>
      {message && <Typography variant="body2">{message}</Typography>}
    </Box>
  );
}
